import React from 'react';
import { Box, Typography, Avatar, Link } from '@mui/material';
import Logo from './../../icons/logo.svg';
import LeaveBoardButton from './LeaveBoardButton';
import { useAccount } from '../../contexts/Account';
import { getAdvisorQueryParams } from '../../utils/queryParams';

const Footer = ({ company }) => {
  const displayYear = new Date().getFullYear();
  const { accountDetails, isFreeTrial, isFreemium } = useAccount();

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 3,
        mb: 1,
      }}
    >
      <Box
        sx={{
          mx: 'auto', // centra horizontalmente
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          px: 2,
        }}
      >
        {/* Icono y texto principal */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Avatar
            alt={`${company.companyName} Logo`}
            src={Logo}
            sx={{
              width: 32,
              height: 32,
              mt: '-4px',
            }}
          />
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#001030',
            }}
          >
            {company.companyName} Advisory Board, Built on AdvisoryCloud
          </Typography>
        </Box>


        {/* Enlaces separados por "|" */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Link
            href={`https://register.advisorycloud.com/boardroom/referral/?${getAdvisorQueryParams(
              {
                accountDetails,
                isFreeTrial,
                isFreemium,
              }
            )}`}
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#2C71F6',
              textDecoration: 'none',
              cursor: 'pointer',
              mb: '4px',
            }}
          >
            Refer a Colleague
          </Link>
          <Typography variant="body2" color="textSecondary">
            |
          </Typography>
          <LeaveBoardButton company={company}></LeaveBoardButton>

        </Box>

        {/* Texto confidencial */}
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
            mb: 0.5,
          }}
        >
          Confidential Board Member Information
        </Typography>

        {/* Copyright */}
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
          }}
        >
          Copyright © {displayYear}, All Rights Reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
